import { getQualifiedServiceName, getPreviewServiceIcon } from "./DashboardUtils";


export default function OverviewInfoDataSource(overviewInfo) {

    const dataSource = overviewInfo?.entries || [];
    const servicePool = ["veridoc", "veriface", "verilive"];

    function asStatsView() {

        const getTransactionCount = (service_name) => {
            const serviceInfo = dataSource.find(
                (_) => _.service_name === service_name
            );
            return serviceInfo?.num_transactions || 0;
        };
        
        return servicePool.map((service_name) => ({
            title: getQualifiedServiceName(service_name),
            icon: getPreviewServiceIcon(service_name),
            textContent: getTransactionCount(service_name)
        }));
    }

    return { asStatsView };
}